import $axios from "@/api";
import helper from "@/assets/js/helper.js";

const state = () => ({
})

const mutations = {
}

const actions = {
    getCacheBarang() {
        return new Promise( (resolve, reject) => {
            $axios.get(`/cache/barang`).then( (response) => {
                resolve(response.data)
            })
        })
    },
    getCacheGudang() {
        return new Promise( (resolve, reject) => {
            $axios.get(`/cache/gudang`).then( (response) => {
                resolve(response.data)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
